import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';
import { classes } from '~utils/ClassNames';
import { ITransOfferObject } from '~api/CartAPI/ICartApiSdk';

const DiscountDetailWrapper = styled.div`
    margin-inline-start: 0.75rem;
    width: 100%;
`;
const DiscountLineItem = styled.div``;
const discountDetailsClass = classes('discount-details');
const discountLineItem = classes('discount-line-item');

export const DiscountDetailsView = observer(({ offers }: Record<'offers', ITransOfferObject[]>) => {
    return (
        <DiscountDetailWrapper className={discountDetailsClass}>
            {offers.map(({ offer_name, benefit_value, discount }) => {
                return (
                    <DiscountLineItem className={discountLineItem}>
                        <span className="mr-1">{offer_name}</span>
                        <span className="mr-1">{benefit_value}</span>
                        {discount && <span className="mr-1">({discount})</span>}
                    </DiscountLineItem>
                );
            })}
        </DiscountDetailWrapper>
    );
});
